import React, { useState, useEffect, useRef } from 'react';
import useGetListaURL from '../../hooks/useGetListaURL.js';
import ComboSelector, { TipoClave } from '../UI/campos/ComboSelector.js';
import MensajeError from '../UI/MensajeError.js';

const SelectParametro = (props) => {
  const estilo = props.estilo;
  const tipoParametro = props.tipoParametro;
  const tipoObjeto = props.tipoObjeto;
  const parametroActual = props.valor;
  const allowedCodigos = props.allowedCodigos;
  const [lista, setLista] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();
  const path = tipoParametro && tipoParametro.path;

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  // keep a ref to fetchData so its changing identity doesn't retrigger this effect
  const fetchDataRef = useRef(fetchData);
  useEffect(() => {
    fetchDataRef.current = fetchData;
  }, [fetchData]);

  useEffect(() => {
    console.log('SelectParametro - UseEffect:', path, tipoObjeto, allowedCodigos);
    const handleLista = (data) => {
      console.log('SelectParametro - handleLista:', data);
      if (allowedCodigos && allowedCodigos.length > 0) {
        setLista((data || []).filter((d) => allowedCodigos.includes(d.codigo)));
      } else {
        setLista(data || []);
      }
    };

    if (path) {
      if (tipoObjeto) {
        fetchDataRef.current(path + '?tipoObjeto=' + tipoObjeto, handleLista);
      } else {
        fetchDataRef.current(path, handleLista);
      }
    }
    // intentionally not including fetchData in deps because its identity may change each render
  }, [path, tipoObjeto, allowedCodigos]);

  const onParametroElegido = (parametroElegido) => {
    props.onChange(parametroElegido);
  };

  return (
    <React.Fragment>
      <ComboSelector
        estilo={estilo}
        lista={lista}
        valorActual={parametroActual ? parametroActual.descripcion : ''}
        campoClave={TipoClave.CODIGO}
        campoDescripcion="descripcion"
        isCargando={isCargando}
        onItemElegido={onParametroElegido}
      />
      <MensajeError errores={erroresGetLista} />
    </React.Fragment>
  );
};

export default SelectParametro;
